// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__11z9f","footer":"ModalInfo_footer__1A1hT"};